import { useCallback, useEffect, useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { useQuery } from 'react-query';
import ClusteredChart from '../../../../../Components/AmCharts/ClusteredChart';
import DonutChart from '../../../../../Components/AmCharts/DonutChart';
import { Loading } from '../../../../../Components/Loading/Loading';
import { GetClienteGarantiaData, GetClienteGarantiaResumen } from '../../../../../api/Api';
import { Alert } from 'react-bootstrap';

export default function ClienteConGarantia() {


  const [isLoading, setIsLoading] = useState(false);
  const [ruc, setRuc] = useState(null);
  const [nroContrato, setNroContrato] = useState(null);
  const [msgNoData, setMsgNoData] = useState(null);

  const { data: dataDummyDonut } = useQuery("getClienteGarantiaResumen", () => GetClienteGarantiaResumen());
  const {
    data: clienteGarantiaDataQuery,
    refetch: refetchClienteGarantia,
    isFetching: isFetchingClienteGarantia
  } = useQuery("getClienteGarantiaData", () => GetClienteGarantiaData(ruc, nroContrato),
    {
      enabled: false,
      onSuccess: (response) => {
        if (!response?.data || (!response.data.ruc?.length > 0 && !response.data.contratos?.length > 0)) {
          setMsgNoData("No se encontraron datos.")
        } else if (!response?.data?.ruc?.length > 0) {
          setMsgNoData("El RUC no existe.")
        } else if (!response?.data?.contratos?.length > 0) {
          setMsgNoData("El Nro de Contrato no existe.")
        }
      }
    });


  const filterClienteGarantia = useCallback(() => {
    if (ruc || nroContrato) {
      setMsgNoData(null);
      refetchClienteGarantia();
    }
  }, [nroContrato, refetchClienteGarantia, ruc]);

  useEffect(() => {
    setIsLoading(isFetchingClienteGarantia)
  }, [isFetchingClienteGarantia])

  const validationRuc = useCallback((e) => {
    const inputValue = e.target.value;
    const numerosEnteros = inputValue.replace(/\D/g, "");
    if (numerosEnteros.length <= 11) {
      setRuc(numerosEnteros)
    }
  }, [])

  const validationNroContrato = useCallback((e) => {
    const inputValue = e.target.value;
    const numerosEnteros = inputValue.replace(/\D/g, "");
    setNroContrato(numerosEnteros)
  }, [])

  return (
    <>
      <Accordion defaultActiveKey={['0']} alwaysOpen>
        <Accordion.Item eventKey="0">
          <Accordion.Header><i className="fi fi-rr-ballot-check fs-3 me-2"></i><span className="fs-4">Total de Clientes</span></Accordion.Header>
          <Accordion.Body>
            <div className="row">
              <div className="col-12">
                <DonutChart
                  id="donutXClientGarantia"
                  data={dataDummyDonut?.data}
                  isDonut={true}
                  category={"categoria"}
                  value={"cantidad"}
                  className={"donut-char"}
                  tooltipText={"Cantidad: [bold]{value}[/] \n Importe: [bold]S/. {importe}[/]"}
                />
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header><i className="fi fi-rr-ballot-check fs-3 me-2"></i><span className="fs-4">Ruc y Contratos</span></Accordion.Header>
          <Accordion.Body>
            <div className="row">
              <div className="col-12">

                <div className="row mb-6">
                  <div className="col-12 d-flex align-items-start gap-4">
                    <div>
                      <label className="fs-5 fw-bold">Ruc</label>
                      <div className='d-flex'>
                        <input
                          className="form-control form-control-solid"
                          value={ruc ?? ""}
                          onInput={validationRuc}
                        />
                      </div>
                    </div>
                    <div>
                      <label className="fs-5 fw-bold">Nro Contrato</label>
                      <div className='d-flex align-items-center'>
                        <input
                          className="form-control form-control-solid"
                          value={nroContrato ?? ""}
                          onInput={validationNroContrato}
                        />
                        <button
                          type="button"
                          className="btn btn-primary ms-4 me-4"
                          onClick={filterClienteGarantia}
                          disabled={!ruc && !nroContrato}>
                          Filtrar
                        </button>
                        {isLoading && (
                          <Loading></Loading>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {msgNoData && (
                  <div className="row">
                    <div className='col-12'>
                      <Alert key={"ss"} variant={'warning'}>
                        {msgNoData}
                      </Alert>
                    </div>
                  </div>
                )}

                {clienteGarantiaDataQuery?.data?.ruc?.length > 0 ? (
                  <ClusteredChart
                    id={"clusteredEmpresasGarantia"}
                    title={"Por Ruc"}
                    data={clienteGarantiaDataQuery?.data.ruc}
                    className={"clustered-chart"}
                    category={"razon_social"}
                    barPrimary={"importe_activos"}
                    barSecondary={"importe_inactivos"}
                    barPrimaryName={"Activos"}
                    barSecondaryName={"Retirados"}
                    barPrimaryTooltip={"Importe Total: [bold]S/ {valueX}[/]"}
                    barSecondaryTooltip={"Importe Total: [bold]S/ {valueX}[/]"}
                    horizontal={true}
                  />
                ) : (
                  <>
                  </>
                )}

              </div>
              <div className="col-12 mt-6">
                {clienteGarantiaDataQuery?.data?.contratos?.length > 0 ? (
                  <ClusteredChart
                    id={"ClusteresEmpresaContratosGarantia"}
                    title={"Por Contrato(s)"}
                    data={clienteGarantiaDataQuery?.data.contratos}
                    className={"clustered-chart"}
                    category={"nroContrato"}
                    barPrimary={"importeActivos"}
                    barSecondary={"importeInactivos"}
                    barPrimaryName={"Activos"}
                    barSecondaryName={"Retirados"}
                    barPrimaryTooltip={"Importe Total: [bold]S/ {valueX}[/]"}
                    barSecondaryTooltip={"Importe Total: [bold]S/ {valueX}[/]"}
                    horizontal={true}
                  />
                ) : (
                  <></>
                )}


              </div>

            </div>

          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  )
}